var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Observer } from "mobx-react-lite";
import React, { useRef, useState } from "react";
import { ContextColor } from "../../constants/color.enum";
import { useContextColorStyle } from "../../hooks/useContextColor.hook";
import joinClassName from "../../utils/className.utils";
import BaseIcon from "../BaseIcon/BaseIcon";
import './CommandListItem.scss';
export var CommandListItem = function (props) {
    var ref = useRef(null);
    var _a = useState(), awaitingResponse = _a[0], setAwaitingResponse = _a[1];
    var handleComponentClick = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (props.disabled) {
                        if (e) {
                            e.preventDefault();
                            e.stopPropagation();
                        }
                        return [2 /*return*/];
                    }
                    if (!props.onClick) return [3 /*break*/, 5];
                    setAwaitingResponse(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, props.onClick(e)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    throw (error_1);
                case 4:
                    setAwaitingResponse(false);
                    return [7 /*endfinally*/];
                case 5:
                    if (props.to) {
                        if (props.openInNewTab) {
                            window.open(props.to, '_blank');
                            return [2 /*return*/];
                        }
                        if (props.to.match(/^http/)) {
                            window.location.href = props.to;
                            return [2 /*return*/];
                        }
                        // NAVIGATOR.navigateTo(props.to);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var style = useContextColorStyle(ContextColor.Primary, props.color);
    return React.createElement(Observer, { children: function () { return (React.createElement("div", { className: joinClassName('CommandListItem', props.className, props.disabled && 'disabled', (props.onClick || props.to) && 'interactable', awaitingResponse && 'awaitingResponse', props.noPointer && 'noPointer'), ref: ref, onClick: handleComponentClick, style: style, "data-cy": props.dataCy, title: props.title },
            props.icon && React.createElement(BaseIcon, { name: props.icon, variant: "filled", size: "1.6rem" }),
            React.createElement("div", { className: "CommandListItem__inner" }, props.children))); } });
};
